import { IconLibrary } from './IconLibrary'
import { EMPTY_FIELD_VALUE } from './fieldValue'

/**
 * L'éditeur du type de champ `icon` — il ouvre LA bibliothèque d'icônes.
 *
 * Déclaré `surface: 'fullscreen'` dans le registre (comme les deux champs
 * image) : le `FieldEditorPopover` le rend alors nu, sans son habillage de
 * popover ancré, car la bibliothèque porte son propre dialogue en portail.
 */
export const IconEditor = ({ value, label, onSave, onClose }) => (
  <IconLibrary
    value={value}
    title={label ? `Bibliothèque d’icônes — ${label}` : 'Bibliothèque d’icônes'}
    onClose={onClose}
    onPick={(name) => onSave(name)}
    // `surface: 'fullscreen'` court-circuite le chrome du `FieldEditorPopover` :
    // le « Vider » générique n'y paraît jamais, la commande vit donc ici.
    onClear={() => onSave(EMPTY_FIELD_VALUE)}
  />
)
